module.exports = __webpack_public_path__ + "img/img1.4577a8ae.png";